import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import ProjectTableService from '../service/ProjectTableService';

const config = {
	key: 'projectTable',
	text: 'Project',
	textKey: 'project',
	service: ProjectTableService,
	editFormState: item => `/project/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function ProjectTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('projectTable', reducer('projectTable'))(ProjectTable);
